import { AxiosResponse } from "axios";
import { API } from "helpers";
import { IAdvanceSearch } from "types";

export const resultFormatter = (result: AxiosResponse<any>) => {
  const cKeys = ['DONOTMAIL', 'DONOTEMAIL', 'DONOTCALL', 'DMOPTOUT', 'CALLOPTOUT', 'FRAGRANCEOPTOUT', 'CCPADELETE', 'CCPAKNOW', 'CCPAOPTOUTSELL', 'INDIVHEADOFHOUSEHOLD'];

  result.data.result = result.data.result.map(r => {
    const newObj = {};

    Object.keys(r).forEach(k => {
      if (cKeys.includes(k)) {
        if (r[k].toLowerCase() === 'unknown') {
          newObj[k.toLowerCase()] = 'N';
        } else {
          newObj[k.toLowerCase()] = r[k];
        }
      } else {
        if (r[k] === 'UNDEFINED') {
          newObj[k.toLowerCase()] = null;
        } else {
          newObj[k.toLowerCase()] = r[k];
        }
      }
    });

    return newObj;
  });

  result.data.count = result.data.result.length > 0 ? result.data.result[0].totalrows : 0;

  return result;
}

export const searchCustomer = (
  searchTerm: string,
  limit: number,
  page: number
) => {
  return API(
    {},
    {
      Authorization: localStorage.getItem("bearerToken"),
    }
  ).post("snowflake/customers/search", {
    firstName: searchTerm ? `${searchTerm}%` : '*',
    lastName: "*",
    email: "*",
    zip: "*",
    city: "*",
    state: "*",
    country: "*",
    masterCustomerId: "*",
    pageSize: limit,
    pageNum: page
  })
  .then(resultFormatter)
};

export const filterCustomer = (limit: number, page: number, fields: IAdvanceSearch[]) => {
  const body = {
    firstName: '*',
    lastName: "*",
    email: "*",
    zip: "*",
    city: "*",
    state: "*",
    country: "*",
    masterCustomerId: "*",
    pageSize: limit,
    pageNum: page
  };

  fields.forEach((item) => {
    item.value = item.value.replace(/'/g, "''");

    switch (item.name) {
      case "First name":
        body.firstName = (item.isSelected && item.searchType !== "Start with") ? (item.value !== '' ? item.value : '*') : (item.value !== '' ? `${item.value}%` : '*');
        break;
      case "Last name":
        body.lastName = (item.isSelected && item.searchType !== "Start with") ? (item.value !== '' ? item.value : '*') : (item.value !== '' ? `${item.value}%` : '*');
        break;
      case "Email address":
        body.email = (item.isSelected && item.searchType !== "Start with") ? (item.value !== '' ? item.value : '*') : (item.value !== '' ? `${item.value}%` : '*');
        break;
      case "City":
        body.city = (item.isSelected && item.searchType !== "Start with") ? (item.value !== '' ? item.value : '*') : (item.value !== '' ? `${item.value}%` : '*');
        break;
      case "State":
        body.state = (item.isSelected && item.searchType !== "Start with") ? (item.value !== '' ? item.value : '*') : (item.value !== '' ? `${item.value}%` : '*');
        break;
      case "Country":
        body.country = (item.isSelected && item.searchType !== "Start with") ? (item.value !== '' ? item.value : '*') : (item.value !== '' ? `${item.value}%` : '*');
        break;
      case "Master Customer Id":
        body.masterCustomerId = (item.isSelected && item.searchType !== "Start with") ? (item.value !== '' ? item.value : '*') : (item.value !== '' ? `${item.value}%` : '*');
        break;
    }
  });

  return API(
    {},
    {
      Authorization: localStorage.getItem("bearerToken"),
    }
  ).post("snowflake/customers/search", body)
  .then(resultFormatter)
};

export const updateCustomer = (
  aquiaId,
  sourceCustomerNumber,
  firstname,
  middlename,
  lastname,
  address1,
  address2,
  city,
  state,
  zip,
  country,
  email,
  primaryPhone,
  dob,
  status,
  identificationId,
  hhId,
  hhHead,
  gender,
  employeeId,
  contactDirectMail,
  contactDirectMailUpdatedAt,
  contactEmail,
  contactEmailUpdatedAt,
  contactPhoneCall,
  contactPhoneCallUpdatedAt,
  contactPhoneText,
  contactPhoneTextUpdatedAt,
  contactFragrance,
  contactFragranceOptionUpdatedAt,
  ccpaRightToOptout,
  ccpaRightToOptoutUpdatedAt,
  ccpaRightToDelete,
  ccpaRightToDeleteUpdatedAt,
  ccpaRightToKnow,
  ccpaRightToKnowUpdatedAt,
  cbelkDataSource,
  csOptinClientelingTexts,
  csOptinClientelingTextsUpdatedAt,
  csOptinClientelingEmails,
  csOptinClientelingEmailsUpdatedAt,
  csOptinClientelingExclusion,
  csOptinClientelingExclusionUpdatedAt
) => {
  return API(
    {},
    {
      Authorization: localStorage.getItem("bearerToken"),
      "Acquia-Auth": `Bearer ${localStorage.getItem("token")}`,
    }
  ).post("customers/", {
    aquiaId,
    sourceCustomerNumber,
    firstname,
    lastname,
    email,
    address1,
    address2,
    city,
    state,
    zip,
    primaryPhone,
    status,
    dob,
    identificationId,
    hhId,
    hhHead,
    gender,
    employeeId,
    contactDirectMail,
    contactDirectMailUpdatedAt,
    contactEmail,
    contactEmailUpdatedAt,
    contactPhoneCall,
    contactPhoneCallUpdatedAt,
    contactPhoneText,
    contactPhoneTextUpdatedAt,
    contactFragrance,
    contactFragranceOptionUpdatedAt,
    ccpaRightToOptout,
    ccpaRightToOptoutUpdatedAt,
    ccpaRightToDelete,
    ccpaRightToDeleteUpdatedAt,
    ccpaRightToKnow,
    ccpaRightToKnowUpdatedAt,
    createdAt: null,
    updatedAt: null,
    middlename,
    country,
    cbelkDataSource,
    csOptinClientelingTexts,
    csOptinClientelingTextsUpdatedAt,
    csOptinClientelingEmails,
    csOptinClientelingEmailsUpdatedAt,
    csOptinClientelingExclusion,
    csOptinClientelingExclusionUpdatedAt
  });
};

export const updateBulkCustomer = (payload: any) => {
  return API(
    {},
    {
      Authorization: localStorage.getItem("bearerToken"),
      "Acquia-Auth": `Bearer ${localStorage.getItem("token")}`,
    }
  ).post("customers/bulk-save/", payload);
};

export const getCustomer = (id: string) => {
  return API(
    {},
    {
      Authorization: localStorage.getItem("bearerToken"),
    }
  ).get(`snowflake/customers/${id}`)
  .then(resultFormatter);
};

export const getPrivacyPreferenceCustomer = (aquiaid: string) => {
  return API(
    {},
    {
      Authorization: localStorage.getItem("bearerToken"),
    }
  ).get(`privacyPreference/getCustomerPrivacyPrefernce/${aquiaid}`)
   .then((response) => {
    const formattedData = {
      aquiaId: response.data.aquiaId,
      enablePrivacyPreferences: response.data.enablePrivacyPreferences,
      freshServiceTicketNo: response.data.freshServiceTicketNo,
      modifiedBy: response.data.modifiedBy,
      modifiedDate: response.data.modifiedDate,
    };
    return formattedData; // Assuming response.data contains the data
  });
};

export const updatePrivacyPreferenceCustomer = (payload1: any) => {
  return API(
    {},
    {
      Authorization : localStorage.getItem("bearerToken"),
      'Content-Type': 'application/json'
    }
  ).post("privacyPreference/updateCustomerPrivacyPreference/", payload1);
};
